module.exports = __webpack_public_path__ + "img/event-org.a0e99f27.png";